import { Link } from "@heroui/link";
import { button as buttonStyles } from "@heroui/theme";

import { subtitle, title } from "../components/primitives";

export default function IndexPage() {
  // //@ts-ignore
  // const [deferredPrompt, setDeferredPrompt] = useState(null);
  //
  // const handleInstall = () => {
  //   if (deferredPrompt) {
  //     deferredPrompt.prompt();
  //
  //     deferredPrompt.userChoice.then(function (choiceResult) {
  //       console.log(choiceResult.outcome);
  //
  //       if (choiceResult.outcome === "dismissed") {
  //         console.log("User cancelled installation");
  //       } else {
  //         console.log("User added to home screen");
  //       }
  //     });
  //   }
  // };

  return (
    <section className="flex flex-col items-center justify-center gap-4 py-8 md:py-10">
      <div className="inline-block max-w-lg text-center justify-center">
        <h1 className={title()}>Lorem&nbsp;</h1>
        <h1 className={title({ color: "violet" })}>lorem&nbsp;</h1>
        <br />
        <h1 className={title()}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
        </h1>
        <h4 className={subtitle({ class: "mt-4" })}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
        </h4>
      </div>

      <div className="flex gap-3">
        <Link
          className={buttonStyles({
            color: "primary",
            radius: "full",
            variant: "shadow",
          })}
          href={"/register"}
        >
          Get Started
        </Link>
        {/*{deferredPrompt && (*/}
        {/*  <button*/}
        {/*    className={buttonStyles({*/}
        {/*      color: "primary",*/}
        {/*      radius: "full",*/}
        {/*      variant: "shadow",*/}
        {/*    })}*/}
        {/*    onClick={handleInstall}*/}
        {/*  >*/}
        {/*    Install App*/}
        {/*  </button>*/}
        {/*)}*/}
      </div>
    </section>
  );
}
